<template>
    <div class="category_filter_items">

        <div v-for="(item) in items" :key="item.id"
             class="category_filter_item"
             @click="this.$router.push({
                name: 'ShopCategory',
                params: {
                    categoryId: item.id,
                },
                query: {
                    categoryName: item.name
                }
             })"
        >
            {{ item.name }}
        </div>

    </div>
</template>

<script>

    import api from "../../api";

    export default {
        name: "ShopCategoryFilter",
        data() {
            return {
                categories: null,
            }
        },
        created() {
            this.loadCategories();
        },
        computed: {
            items: function () {
                return this.$route.params.categoryId !== undefined ? this.categories : this.$store.getters.shopMainCategories
            }
        },
        methods: {
            async loadCategories() {
                let categoryId = this.$route.params.categoryId

                if (categoryId === undefined){
                    if (this.$store.getters.shopMainCategories.length === 0){
                        this.$store.dispatch('loadShopMainCategories')
                    }
                }else{
                    this.categories = (await api.shop.getCategories({
                        params: {
                            id: categoryId
                        }
                    })).data.items;
                }
            },
        },
    }
</script>